import React from "react";
import Tooltip from "@mui/material/Tooltip";
import Box from "components/common/Box";
import Stack from "components/common/Stack";
import Text from "components/common/Text";
import Image from "components/common/Image";
import { config } from "config";
import useNseMarketSession from "hooks/useNseMarketSession";
import { NAV_COLORS } from "components/allInOneDashboard/constants/navTheme";

const CLOSED_DOT = "#9CA3AF";
const CLOSED_TEXT = "#6B7280";

const MarketLiveDot = ({ isLive }) => {
  const color = isLive ? NAV_COLORS.liveGreen : CLOSED_DOT;

  return (
    <Box
      component="span"
      sx={{
        position: "relative",
        width: 14,
        height: 14,
        flexShrink: 0,
        display: "inline-flex",
        alignItems: "center",
        justifyContent: "center",
      }}
    >
      {isLive ? (
        <Box
          component="span"
          aria-hidden
          sx={{
            position: "absolute",
            width: 10,
            height: 10,
            borderRadius: "50%",
            bgcolor: NAV_COLORS.liveGreen,
            "@keyframes nseNavbarLivePulse": {
              "0%": { transform: "scale(0.75)", opacity: 0.85 },
              "70%": { transform: "scale(2.2)", opacity: 0 },
              "100%": { transform: "scale(2.2)", opacity: 0 },
            },
            animation: "nseNavbarLivePulse 1.6s ease-out infinite",
          }}
        />
      ) : null}
      <Box
        component="span"
        sx={{
          position: "relative",
          zIndex: 1,
          width: 10,
          height: 10,
          borderRadius: "50%",
          bgcolor: color,
          boxShadow: isLive ? "0 0 6px rgba(0, 230, 118, 0.85)" : "none",
        }}
      />
    </Box>
  );
};

const BrandSection = () => {
  const { isOpen, label, tooltip } = useNseMarketSession();
  const statusColor = isOpen ? NAV_COLORS.liveGreen : CLOSED_TEXT;

  return (
    <Stack
      direction="row"
      alignItems="center"
      spacing={{ xs: 1.5, md: 1.5 }}
      sx={{ minWidth: 0, flexShrink: 0 }}
    >
      <Stack spacing={{ xs: 0.35, md: 0.65 }} sx={{ flexShrink: 0 }}>
        <Box
          sx={{
            height: { xs: 28, md: 40 },
            width: { xs: 110, md: 152 },
            maxWidth: 252,
            "& img": { height: "100%", width: "auto", objectFit: "contain" },
          }}
        >
          <Image
            src="/jarvis-logo.svg"
            alt={config.companyName}
            rootStyle={{ height: "100%", width: "100%" }}
            imgStyle={{ height: "100%", width: "auto", objectFit: "contain" }}
          />
        </Box>
        {/* <Text
          sx={{
            display: { xs: "block", md: "none" },
            fontSize: 11,
            fontWeight: 400,
            color: NAV_COLORS.taglineBlue,
            lineHeight: 1.2,
            letterSpacing: "-0.2px",
          }}
        >
          Investing powered by AI
        </Text> */}
      </Stack>

      <Box
        sx={{
          display: { xs: "none", md: "block" },
          width: "1px",
          height: 42,
          bgcolor: NAV_COLORS.divider,
          flexShrink: 0,
        }}
      />

      <Tooltip title={tooltip} arrow placement="bottom">
        <Stack
          direction="row"
          alignItems="center"
          spacing={2.25}
          sx={{
            display: { xs: "none", md: "flex" },
            flexShrink: 0,
            cursor: "default",
          }}
        >
          <Text
            sx={{
              fontSize: 20,
              fontWeight: 400,
              color: NAV_COLORS.nseText,
              letterSpacing: "-0.6px",
              lineHeight: 1,
            }}
          >
            NSE
          </Text>
          <Stack direction="row" alignItems="center" spacing={1}>
            <MarketLiveDot isLive={isOpen} />
            <Text
              sx={{
                fontSize: 16,
                fontWeight: 300,
                color: statusColor,
                letterSpacing: "-0.48px",
                lineHeight: 1,
              }}
            >
              {label}
            </Text>
          </Stack>
        </Stack>
      </Tooltip>
    </Stack>
  );
};

export default BrandSection;
